import { getClassRange, getUserAllSchoolProperty } from "../utils/utilsUserProcess";
import { getDeepValue } from "./utils";
import { selectEntitiesByFilters } from "../store/views/entityView";

export function hasTabPermission(user, userDetails, isStudent, lang, visibleTo, jsonList, isManager, entities, permissionFilters) {

  if (!visibleTo)
    return true;
  // Full access list overrides everything
  if (visibleTo.fullAccessList && visibleTo.fullAccessList.includes(user?.exidentifier)) {
    return true;
  }

  // White list blocks everyone except listed users
  if (visibleTo.whiteList && visibleTo.whiteList?.length > 0) {
    return visibleTo.whiteList.includes(user?.exidentifier);
  }
  //final project white list
  if (visibleTo.whiteListJsonKey) {
    const list = jsonList?.[visibleTo.whiteListJsonKey] || [];
    if (!list.includes(user?.exidentifier)) {
      return false;
    }
  }
  // white list by schoolId (e.g. bagrut – only schools in list, no class involvement check)
  if (visibleTo.whiteListJsonKeyBySchool) {
    const list = jsonList?.[visibleTo.whiteListJsonKeyBySchool] || [];
    if (!list?.includes(userDetails?.defaultSchool?.id))
      return false;
  }
  // isStudent check
  if (typeof visibleTo.isStudent === "boolean") {
    if (visibleTo.isStudent !== isStudent) return false;
  }

  if (typeof visibleTo.isManager === "boolean") {
    const canSeeManager = isManager
    if (visibleTo.isManager !== canSeeManager) return false;
  }

  // sectors/lang check (OR)
  let sectorOk = true, langOk = true;
  if (visibleTo.sectors) {
    const userSectors = getUserAllSchoolProperty(userDetails, "sectorId");
    sectorOk = userSectors?.some(s => visibleTo.sectors.includes(Number(s)));
  }
  if (visibleTo.lang) {
    langOk = lang === visibleTo.lang;
  }
  if (visibleTo.sectors || visibleTo.lang) {
    if (!(sectorOk || langOk)) return false;
  }

  if ((visibleTo.managersClasses && isManager)) {
    const managersClasses = getClassRange(userDetails);
    if (!managersClasses?.length || managersClasses?.some(cls => visibleTo.managersClasses.includes(Number(cls))))
      return true;
  }

  // studentsClasses
  if (visibleTo.studentsClasses && isStudent) {
    if (!visibleTo.studentsClasses.includes(Number(user?.studentkita))) return false;
  }

  // teachersClasses
  if (visibleTo.teachersClasses && !isStudent) {
    const teacherClasses = getClassRange(userDetails);
    if (!teacherClasses?.some(cls => visibleTo.teachersClasses.includes(Number(cls)))) return false;
  }
  //hasSchoolLink
  if (visibleTo.useSchoolLink) {
    const linkValue = getDeepValue(userDetails?.defaultSchool, visibleTo.useSchoolLink);
    const hasValidLink = Array.isArray(linkValue) ? linkValue?.length > 0 : Boolean(linkValue);
    if (!hasValidLink)
      return false;
  }
  
  // studentApiData
  if (visibleTo.studentApiData && isStudent) {
    const filters = permissionFilters?.[visibleTo.studentApiData];
    return hasMatchingApiEntities(filters, entities);
  }
  // teacherApiData
  if (visibleTo.teacherApiData && !isStudent) {
    const filters = permissionFilters?.[visibleTo.teacherApiData];
    return hasMatchingApiEntities(filters, entities);
  }
  return true;
}

export function getAllowedTabs(user, userDetails, isStudent, lang, permissionLlist, isManager, entities, permissionFilters) {
  const tabsConfig = window.config.tabsConfig || [];
  const allowedTabs = tabsConfig?.filter(tab => hasTabPermission(user, userDetails, isStudent, lang, tab.visibleTo, permissionLlist, isManager, entities, permissionFilters));
  return allowedTabs.filter((tab, index) =>
    !tab.route || allowedTabs.findIndex(allowedTab => allowedTab.route === tab.route) === index
  );
}

const hasMatchingApiEntities = (filters, entities) => {
  if (!filters)
    return true;
  const matchedEntities = selectEntitiesByFilters({ entities: { list: entities } }, filters);
  return matchedEntities?.length > 0;
};

export function getTab(key) {
  return window.config?.tabsConfig?.find(tab => tab.key === key);
}
export function getKey(key) {
  return window.config?.permission?.find(tab => tab.key === key);
}
export function hasPlatformLink(userDetails, key) {
  return Boolean(userDetails?.defaultSchool?.[key]);
}